function extractDomain(apiValue) {
    const extractorRegEx = /^https?:\/\/([A-Za-z\d.\\-]+)(?::\d{1,5})?(?:\/.*)?$/;
    const extractorMatch = apiValue.match(extractorRegEx);
    if (Array.isArray(extractorMatch) && extractorMatch.length === 2) {
        return extractorMatch[1];
    }
    else {
        return null;
    }
}

export default extractDomain;



//////////////////
// WEBPACK FOOTER
// ./src/utility/ExtractDomain.js
// module id = guve
// module chunks = 1